/**
 * JURO — sections that change colour arrive as sheets
 * ------------------------------------------------------------------
 * Where a section's background differs clearly from the one above it
 * (white to navy or back), the lower section slides up over the upper one
 * as a sheet: rounded top corners, a soft shadow, overlapping by the corner
 * radius. assets/juro-flow.css draws it and, where scroll-driven animation
 * is supported, straightens the corners as the sheet comes into view.
 *
 * Third attempt at these seams (2026-09-18): a gradient band looked muddy
 * and curved "horizon" edges did not work either; Julius wants the colour
 * changes kept, only handled better.
 *
 * Colours are read from what each section actually paints, so a section
 * added or recoloured in the theme editor behaves on its own. White against
 * light grey stays a straight line.
 */

(() => {
  if (window.__juroFlow) return;
  window.__juroFlow = true;

  const OPAQUE = (c) => c && c !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(c);
  const luminance = (c) => {
    const [r, g, b] = (c.match(/[\d.]+/g) || []).map(Number);
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  };

  // The colour a section paints: the first opaque background among the
  // wrapper's first few levels that covers most of it.
  const paint = (section) => {
    const h = section.offsetHeight;
    if (h < 40) return null;
    let level = [section];
    for (let depth = 0; depth < 4 && level.length; depth++) {
      for (const el of level) {
        if (el !== section && el.offsetHeight < h * 0.6) continue;
        const bg = getComputedStyle(el).backgroundColor;
        if (OPAQUE(bg)) return bg;
      }
      level = level.flatMap((el) => [...el.children]);
    }
    return null;
  };

  const run = () => {
    const sections = [...document.querySelectorAll('main .shopify-section')].filter((s) => s.offsetHeight >= 40);
    const colours = sections.map(paint);
    sections.forEach((s, i) => {
      s.removeAttribute('data-juro-sheet');
      s.style.removeProperty('--juro-sheet-bg');
      const me = colours[i];
      const prev = colours[i - 1];
      if (!me || !prev || Math.abs(luminance(me) - luminance(prev)) < 0.35) return;
      s.style.setProperty('--juro-sheet-bg', me);
      s.setAttribute('data-juro-sheet', luminance(me) < 0.35 ? 'dark' : 'light');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  // theme editor: sections added, removed, moved or re-rendered
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((e) =>
    document.addEventListener(e, () => requestAnimationFrame(run))
  );
})();
